<template>
  <div class="rightsCardItem" v-for="item in couponList" :key="item.id" @click="showRightDetail(item)">
    <div class="dentation"></div>
    <div class=" rightsArrow" v-if="showArrow">
      <img src="../../assets/images/arrowRightBlue.png" />
    </div>
    <van-row class="fvlr">
      <van-col span="8">
        <div class="rightsTypeWrap">
          <div class="rightsTypeBox rightsTypeItem" :class="{ activeDiscount: item.rightTypeFlag === 11, hiddenTypeName: item.rightTypeFlag === 12 }">
            <img v-if="item.rightTypeFlag!=13" src="../../assets/images/lineShort.png" />
            <span>{{ item.typeName }}</span>
            <img v-if="item.rightTypeFlag!=13" class="imgReverse" src="../../assets/images/lineShort.png" />
          </div>
          <p class="rightsTypeItem rightsCore">{{ item.discountStr }}</p>
          <p class="rightsTypeItem">{{ item.thresholdStr }}</p>
        </div>
      </van-col>
      <van-col span="1">
        <div class=" dashedBox">
          <div class="dashedLine"></div>
        </div>
      </van-col>
      <van-col span="15">
        <div class=" rightsInfoBox">
          <p class="rightsName">{{ item.rightName }}</p>
          <p class="rightsRule">{{ item.limitStr }}</p>
          <!-- <p v-if="item.activeTypeFlag == 1">有效期：{{ item.activeStartTime }}-{{ item.activeEndTime }}</p> -->
          <!-- <p v-else>有效期：{{ item.activeMonth == -1 ? '无限制' : `${item.activeMonth}个月` }}</p> -->
          <p>有效期：{{ getTime(item) }}</p>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
export default {
  props: ['couponList', 'showArrow', 'scene'],
  emits: ['showCouponDetail'],
  setup(props, { emit }) {
    let { couponList, showArrow, scene } = toRefs(props)
    const state = reactive({
      couponList,
      showArrow,
      scene
    })
    const showRightDetail = data => {
      emit('showCouponDetail', data)
    }
    let getTime = item => {
      let res = ''
      if (item.activeTypeFlag == 1) {
        res = item.activeStartTime + '-' + item.activeEndTime
      } else {
        res = item.activeMonth == -1 ? '无限制' : `${item.activeMonth}个月`
      }
      if (state.scene === 'myRight') {
        res = item.activeStartTime + '-' + item.activeEndTime
      }
      return res
    }
    return {
      ...toRefs(state),
      showRightDetail,
      getTime
    }
  }
}
</script>

<style lang="scss" scoped>
// 专享权益

.rightsCardItem {
  position: relative;
  min-height: 88px;
  padding: 12px 12px 12px 0px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: #fff;
  text-align: center;
}
// 边缘锯齿
.dentation {
  position: absolute;
  width: 5px;
  height: 88px;
  top: 0;
  left: -4px;
  background-image: url(../../assets/images/dentation.png);
}
.rightsArrow {
  position: absolute;
  width: 10px;
  height: 10px;
  margin: auto;
  top: 0;
  bottom: 0;
  right: 15px;
  text-align: center;
  img {
    width: 16px;
    height: 16px;
  }
}
// 左侧类型
.rightsTypeWrap {
  height: 64px;
  color: #666;
  font-size: 12px;
  .rightsTypeItem {
    color: #999;
    font-size: 12px;
  }
  .rightsTypeBox {
    margin-bottom: 5px;
    span {
      margin: 0 4px;
      vertical-align: middle;
    }
    img {
      margin: auto 0;
      vertical-align: middle;
    }
  }
  .activeDiscount {
    img {
      width: 14px;
    }
  }
  .rightsCore {
    margin-bottom: 7px;
    color: #3088c5;
    font-size: 16px;
    font-weight: 700;
  }
}
.imgReverse {
  transform: rotate(180deg);
}
// 分隔虚线
.dashedBox {
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.dashedLine {
  width: 1px;
  height: 50px;
  border-right: 1px dashed #ccc;
}

// 右侧信息
.rightsInfoBox {
  min-height: 64px;
  padding-left: 8px;
  color: #999;
  font-size: 12px;
  text-align: left;
  .rightsName {
    color: #333;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: bold;
  }
  .rightsRule {
    height: 14px;
    color: #666;
    margin-bottom: 8px;
  }
}
.hiddenTypeName {
  visibility: hidden;
}
</style>
